import { Shield } from "lucide-react";
import { Link } from "react-router-dom";
import ChatButton from "./ChatButton";

const footerLinks = {
  product: [
    { name: "Features", href: "#features" },
    { name: "Pricing", href: "/pricing", internal: true },
    { name: "API Documentation", href: "/admin/integration", internal: true },
    { name: "Status", href: "https://solidwraps.statuspage.io", target: "_blank", rel: "noopener noreferrer" }
  ],
  company: [
    { name: "About", href: "/about", internal: true },
    { name: "Blog", href: "https://blog.solidwraps.com", target: "_blank", rel: "noopener noreferrer" },
    { name: "Careers", href: "#careers" },
    { name: "Contact", href: "/contact", internal: true }
  ],
  legal: [
    { name: "Privacy Policy", href: "https://legal.solidwraps.com/solidwraps/privacy-policy/privacy-policy", target: "_blank", rel: "noopener noreferrer" },
    { name: "Terms of Service", href: "https://legal.solidwraps.com/solidwraps/terms-of-service/terms-of-use", target: "_blank", rel: "noopener noreferrer" },
    { name: "Refund Policy", action: "modal" }
  ]
};

const showRefundPolicy = () => {
  if (typeof window !== 'undefined' && (window as any).SolidwrapsModal) {
    const modal = (window as any).SolidwrapsModal.init({
      apiKey: 'sk_K3SbnRYpkQyqUsmkw7SjnoYEp1hmj',
      policyType: 'Refund Policy', 
      userReference: 'website-visitor-' + Date.now(),
      customization: {
        theme: 'light',
        primaryColor: '#3b82f6'
      },
      onConsent: (consentId: string) => {
        console.log('Refund policy consent recorded:', consentId);
      },
      onDecline: () => {
        console.log('Refund policy consent declined');
      },
      onError: (error: string) => {
        console.error('Modal error:', error);
      }
    });
    modal.show();
  } else {
    console.error('SolidwrapsModal not loaded');
  }
};

const Footer = () => {
  return (
    <footer className="bg-background border-t border-border">
      <div className="container mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <Shield className="h-8 w-8 text-primary" />
              <span className="text-2xl font-bold text-foreground">SolidWraps</span>
            </div>
            <p className="text-muted-foreground mb-4 max-w-md">
              The most trusted platform for clickwrap consent management. 
              Secure, compliant, and developer-friendly.
            </p>
            <div className="flex items-center space-x-4 mb-4">
              <ChatButton 
                variant="outline" 
                size="sm"
                className="text-xs"
              >
                Need help? Chat with us
              </ChatButton>
            </div>
            <div className="text-sm text-muted-foreground">
              © {new Date().getFullYear()} SolidWraps. All rights reserved.
            </div>
          </div>

          <div>
            <h3 className="font-semibold text-foreground mb-4">Product</h3>
            <ul className="space-y-3">
              {footerLinks.product.map((link, index) => (
                <li key={index}>
                  {link.internal ? (
                    <Link 
                      to={link.href} 
                      className="text-muted-foreground hover:text-foreground transition-colors"
                    >
                      {link.name}
                    </Link>
                  ) : (
                    <a 
                      href={link.href} 
                      className="text-muted-foreground hover:text-foreground transition-colors"
                      target={link.target || "_self"}
                      rel={link.rel || ""}
                    >
                      {link.name}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-foreground mb-4">Company</h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  {link.internal ? (
                    <Link 
                      to={link.href} 
                      className="text-muted-foreground hover:text-foreground transition-colors"
                    >
                      {link.name}
                    </Link>
                  ) : (
                    <a 
                      href={link.href} 
                      className="text-muted-foreground hover:text-foreground transition-colors"
                    >
                      {link.name}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-foreground mb-4">Legal</h3>
            <ul className="space-y-3">
              {footerLinks.legal.map((link, index) => (
                <li key={index}>
                  {link.action === 'modal' ? (
                    <button
                      onClick={showRefundPolicy}
                      className="text-muted-foreground hover:text-foreground transition-colors cursor-pointer bg-transparent border-none p-0 text-left"
                    >
                      {link.name}
                    </button>
                  ) : (
                    <a 
                      href={link.href} 
                      className="text-muted-foreground hover:text-foreground transition-colors"
                      target={link.target || "_self"}
                      rel={link.rel || ""}
                    >
                      {link.name}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;